import {getStory} from '../utils/api'
import {Comment} from '../components/comment'

tag article-page
	def routed params
		window.scrollTo(0, 0)
		story = await getStory params.id
	<self>
		<div.item-view>
			<div.item-view-header [d:grid gap:4]>
				<a href=story.url target="_blank">
					<h1> story.title
					if story.domain
						<span.host> "({story.domain})"
				<p.meta> "{story.points} points | by "
					<a route-to=`/user/{story.user}`> "{story.user} "
					story.time_ago
			<div.item-view-comments>
				<p.item-view-comments-header> "{story.comments_count ? story.comments_count + " comments" : "No comments yet."}"
				<ul.comment>
					for comment in story.comments
						<li>
							<Comment comment=comment >